PLAN_ID_BULK_GIFT_THREE_MONTH